import {useEffect, useRef, useState} from 'react';
import SlowText from "./SlowText";
import * as React from "react";

export default function ChatHistory({history}) {

    const divRef = useRef(null);
    useEffect(() => {
        divRef.current.scrollIntoView({behavior: 'smooth'});
    });

    const chatHistory = history.map((message, msgNum) => {

        if (message.author === "sys") {
            return (
                <div className="ai-message-block">
                    <span className="message-icon-left message-icon-ai material-symbols-outlined">psychology</span>
                    <span className="message-icon-right material-symbols-outlined">content_copy</span>
                    <SlowText speed={60} text={message.content}/>
                </div>)
        } else if (message.author === "ai") {

            if (message.loading === true) {

                return (<div className="ai-message-block rainbow">
                    <span className="message-icon-center material-symbols-outlined spinning">settings</span>
                </div>)

            } else {


                return (<div className="ai-message-block">
                    <span className="message-icon-left message-icon-ai material-symbols-outlined">psychology</span>
                    <span className="message-icon-right material-symbols-outlined">content_copy</span>
                    <span className="message-icon-bottom-right-1 material-symbols-outlined">thumb_up</span>
                    <span className="message-icon-bottom-right-2 material-symbols-outlined">thumb_down</span>
                    <SlowText speed={50} text={message.content}/>
                </div>)
            }
        } else {
            return (<div className="user-message-block">
                <span className="message-icon-left message-icon-user material-symbols-outlined">account_box</span>
                <p>{message.content}</p>
            </div>)
        }

    });

    return (
        <div className="chat-history-wrapper">
            {chatHistory}
            <div ref={divRef}/>
        </div>

    );
}